<div id="logo-main-item-wrapper">
  <div id="header-wrapper">
    <div (click)="goToDashboard()" id="logo-wrapper">
      <msd-logo id="small-logo" [size]="'40px'" [small]="true"></msd-logo>
      <msd-logo id="large-logo" [small]="false"></msd-logo>
    </div>
    <hr>
  </div>

  <ul id="navigation-items-wrapper" class="nav nav-pills mb-auto">
    <msd-sidebar-cell *ngFor="let item of items" (click)="onChange(item)" [name]="item.label" [icon]="item.icon"
                      [isActive]="item.selected" [onlyDesktop]="item.onlyDesktop">
    </msd-sidebar-cell>
    <msd-sidebar-cell (click)="onChange(msdpSideBarItem)"
                      *ngIf="msdpSideBarItem"
                      [icon]="msdpSideBarItem.icon"
                      [isActive]="msdpSideBarItem.selected"
                      [name]="msdpSideBarItem.label"
                      [onlyDesktop]="msdpSideBarItem.onlyDesktop">
    </msd-sidebar-cell>
  </ul>
</div>

<div id="miscs-items-wrapper">
  <ul class="nav nav-pills mb-auto">
    <msd-avatar-sidebar-cell (click)="onAccountSettings()"
                             [avatarUrl]="dietitian?.picture?.url"
                             [initials]="dietitian?.initials"
                             [isActive]="isAccountActive"
                             [label]="dietitian?.firstName + ' ' + dietitian?.lastName"
    ></msd-avatar-sidebar-cell>
  </ul>
  <hr>
  <ul class="nav nav-pills mb-auto">
    <msd-sidebar-cell (click)="signOut.emit()" [name]="'Déconnexion'" [icon]="'iconly-Logout'">
    </msd-sidebar-cell>
  </ul>
</div>
